"use client";
import { useState, useEffect } from "react";
import { Link } from "@/navigation.ts";
import { getInquiry } from "@/lib/utils/util";
import CountBadge from "@/components/Badge/count-badge";

const InquiryBtn = ({ lastScrollPosition }: { lastScrollPosition: number }) => {
	const [inquiryCount, setInquiryCount] = useState(0);
	const isTransparent = lastScrollPosition <= 40;

	useEffect(() => {
		const handleStorageChange = () => {
			const inquiryData = getInquiry();
			setInquiryCount(inquiryData.length > 99 ? 99 : inquiryData.length);
		};

		handleStorageChange();

		window.addEventListener("storage", handleStorageChange);

		return () => window.removeEventListener("storage", handleStorageChange);
	}, []);

	return (
		<li className="c-flex cursor-pointer max-md:!hidden">
			<Link
				href="/inquiry"
				className={`group flex h-10 w-10 items-center justify-center rounded-full transition-all ${
					!isTransparent ? " hover:bg-black/10" : "bg-transparent hover:bg-white/10"
				}`}
			>
				<div className={`c-flex relative h-[42px] w-[42px] rounded-full text-black ${"hover:bg-[#F3F4F6]"}`}>
					<i className={`ri-file-list-line relative text-2xl`}>
						<CountBadge count={inquiryCount} />
					</i>
				</div>
			</Link>
		</li>
	);
};

export default InquiryBtn;
